import React from 'react'
import config from '@/utils/config'

const component = () => <strong>{config.appName}</strong>

export default React.memo(component)
